import * as ApiManager from './_manager';
import store from '../store';

export const screening = {
  todayList: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/today`,
      payload,
    );
  },
  upcomingList: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/upcoming`,
      payload,
    );
  },
  ongoingList: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/ongoing`,
      payload,
    );
  },
  listVodEvents: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/vod`,
      payload,
    );
  },
  archiveList: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/archive`,
      payload,
    );
  },
  get: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/get`,
      payload,
    );
  }
};
